// removed by extract-text-webpack-plugin
module.exports = {"menu":"_3P9l3KwonkSDzcARnCm9Ho","collaborators-menu":"_3CrxTeFtD8ojD2KXBf4rfX","collaboratorsMenu":"_3CrxTeFtD8ojD2KXBf4rfX"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/NavigationBar/components/MenuWrapper/styles.scss
// module id = 622
// module chunks = 11